// Stuff for the shortcodes

/**
 * checks if a given text is a shortcode and returns it as an object
 *
 * the shortcode must be of the form <p>[short-code-name optionalOption1=value1 optionaOption2=value2]</p>
 * no spaces can be in the option names and neither in the values!
 *
 * This function returns an object in the form of {name: short-code-name, options: {optionaOption1: value1, optionaOption2: value2}}
 * If no options are given an empty object is returned for the options key
 */
exports.isShortCode = (text) => {
    const shortcodeRegex = /^\s*\[.*?\]\s*$/; // The shortcode can have an arbitrary number of white chars in front or after. Hope this breaks nothing else :D
    const rawShortcode = text.match(shortcodeRegex);

    if (!rawShortcode) {
        return false;
    }

    // extract the shortcode information
    const cleanShortcode = rawShortcode[0].trim().replace(/\[|\]/g, ''); // remove surrounding whitespace and the opening and closing brackets
    const shortcodeContent = cleanShortcode.split(' '); // get all the parts of the shortcode
    const shortcode = { name: shortcodeContent.shift() };
    // extract the remaining parameters into an object
    // note: if a property is present (ie. without a value) it is treated as true
    // ie: [shortcode download] -> options = {download: true}
    const shortcodeOptions = shortcodeContent.reduce((obj, item) => {
        const [property, value] = item.split('=');

        return {
            ...obj,
            [property]: value || true,
        };
    }, {});

    shortcode.options = shortcodeOptions;

    return shortcode;
};
